export enum AMSCall {
  getAllMessages,
  getSummary,
  getMessage,
  deleteMessages,
  markAllAsRead,
  markAsRead,
  markAsReadByMetadata,
  notifyUnreadCount,
}
